import { render, staticRenderFns } from "./ModulesField.vue?vue&type=template&id=250ae8de&"
import script from "./ModulesField.vue?vue&type=script&lang=js&"
export * from "./ModulesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports